<template>
	<div class="content">
        <container v-if="!loaded"><loading /></container>
        <div class="md-layout" v-if="loaded">
            <div class="md-layout-item md-xsmall-size-50 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom:15px;display: flex;align-items: center;">
            	<h4 class="application-title" style="font-weight: bold;">{{translate(locale.manage_unit)}}</h4>
        	</div>
			<div class="md-layout-item md-xsmall-size-50 md-small-size-50 md-medium-size-50 md-size-50 text-right" style="margin-bottom:15px">
            	<router-link :to="'/units/new'" ><md-button class="md-raised md-primary" style="padding: 0"><i class="material-icons button-icon">add_circle</i> {{translate(locale.new_unit)}}</md-button></router-link>
        	</div>

			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom:15px" v-if="loaded && unit_list.length === 0">
				<container>
					<p class="text-center text-primary" style="margin: 10px 0;">{{translate(locale.no_unit)}}</p>
				</container>
        	</div>

			<template v-if="unit_list.length > 0">
				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
					<container>
						<div class="md-layout">
							<div class="md-layout-item md-xsmall-size-10 md-small-size-15 md-medium-size-15 md-size-15">
								<div class="table-item-text">{{translate(locale.no)}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-50 md-small-size-45 md-medium-size-45 md-size-45">
								<div class="table-item-text">{{translate(locale.unit_name)}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-40 md-small-size-25 md-medium-size-25 md-size-25">
								<div class="table-item-text">{{translate(locale.unit_user)}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-100 md-small-size-15 md-medium-size-15 md-size-15 text-right">
								<div class="table-item-text" style="justify-content: flex-end;">{{translate(locale.action)}}</div>
							</div>
						</div>
					</container>
				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-for="(unit, index) in unit_list">
					<container>
						<div class="md-layout">
							<div class="md-layout-item md-xsmall-size-10 md-small-size-15 md-medium-size-15 md-size-15">
								<div class="table-item-text">{{index+1}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-50 md-small-size-45 md-medium-size-45 md-size-45">
								<div class="table-item-text">{{unit.name}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-40 md-small-size-25 md-medium-size-25 md-size-25">
								<div class="table-item-text">{{unit.total_user || 0}} {{translate(locale.people)}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-100 md-small-size-15 md-medium-size-15 md-size-15 text-right">
								<md-button class="md-raised md-danger" @click="deleteUnit(unit.hash)"><i class="material-icons button-icon">delete</i>{{translate(locale.delete)}}</md-button>
								<router-link :to="'units/edit/' + unit.hash">
									<md-button class="md-raised md-secondary" style="margin-left: 5px"><i class="material-icons button-icon">edit</i>{{translate(locale.edit)}}</md-button>
								</router-link>
							</div>
						</div>
					</container>
				</div>
			</template>
        </div>
    </div>

</template>

<script>

	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				loaded: false,
				loadMore: false,
				unit_list: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/user/unit/list", {
					offset: more ? this.unit_list.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.unit_list = more ? this.unit_list.concat(data.body.data) : data.body.data;
				})
			},
			deleteUnit(hash) {
				this.$http.post(this.config.api + "/user/unit/delete", {
					hash: hash
				}).then(data => {
					if(data.body.status == 'success') {
						this.$notification.notify({
							message: "You have deleted an unit successfully.||អ្នកបានលុបអង្គភាពដោយជោគជ័យ។",
							icon: 'check_circle',
							type: 'success'
						});
					}
					this.searchHandler();
				})
			}
		}
	}
</script>
<style scoped>
	.table-item-text {
		font-weight: bold;
		color: #353690;
		display: flex;
		height: 100%;
		align-items: center;
	}
	
</style>



// WEBPACK FOOTER //
// src/pages/Units/View.vue